import React, { useEffect, useState, useRef } from "react";
import '../../theme/styles.css';
import './OrderParts.scss';
import OrderInput from "./OrderInput";
import { OrderPart, PartFormData } from "../../Models/Orderpart";
import AddButton from "../AddButton";

interface OrderPartsProps {
  orderParts: OrderPart[];
  onValidRequest?: (isValid: boolean) => void;
  onOrderPartsChange?: (orderParts: OrderPart[]) => void;
  resetTrigger?: number;
}

export default function OrderParts(props: OrderPartsProps) {
  const [rows, setRows] = useState<OrderPart[]>(() => 
    props.orderParts.length > 0 ? props.orderParts : [createEmptyPart()]
  );
  const [inputDataMap, setInputDataMap] = useState<Record<number, PartFormData>>({});
  const [validityMap, setValidityMap] = useState<Record<number, boolean>>({});
  const [resetKey, setResetKey] = useState(0);
  const bottomRef = useRef<HTMLDivElement>(null);

  function createEmptyPart(): OrderPart {
    return {
      id: Date.now(),
      IPC: "",
      PartNumber: "",
      PartName: "",
      Quantity: 0
    };
  }

  useEffect(() => {
    if (props.resetTrigger !== undefined) {
      setRows(props.orderParts.length > 0 ? props.orderParts : [createEmptyPart()]);
      setInputDataMap({});
      setValidityMap({});
      setResetKey(prev => prev + 1);
    }
  }, [props.resetTrigger]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [rows]);

  useEffect(() => {
    props.onValidRequest?.(Object.values(validityMap).every(Boolean) && rows.length > 0);
  }, [validityMap, rows]);

useEffect(() => {
  if (props.onOrderPartsChange) {
    const orderParts = rows.map(row => {
      const rowId = row.id ?? 0;
      const formData = inputDataMap[rowId] || {};
      return {
        ...row,
        IPC: formData.IPC || "",
        PartNumber: formData.PartNumber || "",
        PartName: formData.PartName || "",
        Quantity: Number(formData.Quantity) || 0
      };
    }).filter(part => 
      part.IPC !== "" ||
      part.PartNumber !== "" || 
      part.PartName !== "" || 
      part.Quantity !== 0
    );
    props.onOrderPartsChange(orderParts);
  }
}, [inputDataMap, rows, props.onOrderPartsChange]);


  const handleInputChange = (rowId: number, data: PartFormData) => {
    setInputDataMap(prev => ({ ...prev, [rowId]: data }));
  };

  const addPart = () => {
    if (Object.values(validityMap).every(Boolean)) {
      setRows(prev => [...prev, createEmptyPart()]);
    }
  };

  return (
    <div>
      <div className="input-scroll">
        <div className="input-field">
          {rows.map((row, index) => (
            <div key={`${row.id}-${resetKey}`} className="order-input-row">
              <OrderInput
                rowId={row.id ?? 0}
                index={index}
                onValidityChange={isValid => 
                  setValidityMap(prev => ({ ...prev, [Number(row.id)]: isValid }))
                }
                onDataChange={data => handleInputChange(row.id ?? 0, data)}
                isFirst={index === 0}
              />
            </div>
          ))}
          <div ref={bottomRef} />
        </div>
      </div>

      <AddButton onClick={addPart} disabled={!Object.values(validityMap).every(Boolean)} />
    </div>
  );
}
